export default function Timeline(props) {

    const { className, items } = props;

    if ( !items || !items.length ) {
        return "";
    }

    const itemsPrint = items.map((item, index) => {

        const { date, content } = item;

        let bottomLine;

        if ((index + 1) != items.length) {
            bottomLine = (<div className="sol-timeline-line grow"></div>);
        }

        return (
            <div key={ index } className="bg-white odd:bg-grey flex">
                <p className="hidden sm:block flex-none text-black/50 p-20 w-100">{ date }</p>
                <div className="flex flex-col pl-20 sm:pl-0">
                    <div className={ (index ? "sol-timeline-line " : "") + "h-20" }></div>
                    <div className="sol-timeline-dot"></div>
                    { bottomLine }
                </div>
                <div className="grow p-20">
                    <p className="block sm:hidden text-black/50 pb-20">{ date }</p>
                    <div className="sol-markdown-content">
                        { content }
                    </div>
                </div>
            </div>
        )
    });

    return (
        <div className={ className }>
            { itemsPrint }
        </div>
    )
}